import type { TenantBusinessProfile } from '@/core/types/tenantWorkspace';

/**
 * Keeps tenant-facing names driven by the business type assigned in Platform.
 * The type does not enable or disable any product feature; it only changes
 * descriptive language in the workspace.
 */
export const fallbackTenantBusiness: TenantBusinessProfile = {
  typeCode: 'Organization',
  typeName: 'سازمانی',
  entityName: 'سازمان',
  templateCode: 'organization',
  templateName: 'قالب سازمانی',
  templateDescription: 'پیشنهاد شروع برای تیم فروش، سرنخ‌های B2B و پیگیری‌های چندمرحله‌ای.',
};

export const tenantBusiness = (business?: TenantBusinessProfile | null): TenantBusinessProfile =>
  business ?? fallbackTenantBusiness;
